import { resolveKakaoImageUrl } from "./resolveKakaoImageUrl";

type DeckCardKakaoImageInput = {
  /** Preferred — card cover (`cover_image_url` / `coverImageUrl`). */
  coverImageUrl?: string | null;
  /** @deprecated Use coverImageUrl; kept for callers that only pass imageUrl. */
  imageUrl?: string | null;
};

/** Resolves deck card cover to Kakao custom-template `image_url` (HTTPS, public). */
export const resolveDeckCardKakaoImageUrl = (input: DeckCardKakaoImageInput): string => {
  const raw = input.coverImageUrl?.trim() || input.imageUrl?.trim() || "";
  return resolveKakaoImageUrl(raw || undefined);
};
